import "./hb-header.module.css";
import { html } from "lit-html";

export default (user) => html`
    <hb-menu></hb-menu>
    <hb-navbar></hb-navbar>
    <hb-chest></hb-chest>
    <hb-onboard></hb-onboard>
    <hb-factory></hb-factory>

    <hb-passkey></hb-passkey>
    <hb-lockbox></hb-lockbox>
    <hb-locker></hb-locker>
    <hb-safe></hb-safe>
    <hb-hold></hb-hold>
`;
